import axios, { type AxiosInstance, AxiosError } from 'axios';

type TypeRequest = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
interface ConfigRequest {
  url: string;
  method: TypeRequest;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params?: any;
  signal?: AbortSignal;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any;
}

export class AxiosBase {
  client: AxiosInstance;
  static abortController: AbortController = new AbortController();

  constructor(config: Record<string, unknown>) {
    this.client = axios.create(config);

    this.client.interceptors.response.use(
      (response) => response,
      (error: AxiosError) => Promise.reject(error),
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async excuteRequest(typeRequest: TypeRequest, path: string, params?: any) {
    const config: ConfigRequest = {
      url: path,
      method: typeRequest,
      signal: AxiosBase?.abortController?.signal,
    };

    if (params) {
      if (typeRequest == 'GET') config.params = params;
      else config.data = params;
    }

    return this.client(config)
      .then((response) => {
        return { status: response.status, data: response.data, state: 'success' };
      })
      .catch((error) => {
        return { status: error.status, data: null, state: 'failed' };
      });
  }
}
